import { connect } from 'react-redux'

import { logOut } from './authorizationActions'
import AuthorizedControls from './AuthorizedControls'

const mapStateToProps = (state) => ({
  email: state.authorization.email
})

const mapDispatchToProps = (dispatch) => ({
  onLogOutClick: () => dispatch(logOut())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthorizedControls)
